import {Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChildren} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '@env/environment';
declare const $: any;

@Component({
  selector: 'app-categories-section',
  templateUrl: './categories-section.component.html',
  styleUrls: ['./categories-section.component.css']
})
export class CategoriesSectionComponent implements OnInit {

  @ViewChildren('tab-item') tabItems: ElementRef;

  categories = [
    {name: 'Walmart', turnOff: !environment.turn_on_walmart, alt: 'Walmart', src: 'assets/market-walmart/walmart-category.svg', slug: 'envios/walmart-para-cuba'},
    {name: 'Best Buy', turnOff: !environment.turn_on_bestbuy, alt: 'Best Buy', src: 'assets/market-best-buy/best_buy_category.svg', slug: 'envios/best-buy-para-cuba'},
    {name: 'Home Depot', turnOff: !environment.turn_on_homedepot, alt: 'Home Depot', src: 'assets/market-home-depot/home_depot_category.svg', slug: 'envios/home-depot-para-cuba'},
    {name: 'Amazon', turnOff: !environment.turn_on_amazon, alt: 'Amazon', src: 'assets/market-amazon/amazon.svg', slug: 'envios/amazon-para-cuba'},
    {name: 'Shein', turnOff: !environment.turn_on_shein, alt: 'Shein', src: 'assets/market-shein/icon_shein.png', slug: 'envios/shein-para-cuba'},
    {name: 'Ofertas', alt: 'Ofertas', src: 'assets/market/oferta.jpg', slug: 'tienda-online-cuba/ofertas-descuentos-tienda-envios-cuba'},
    {name: 'Envíos', alt: 'Envíos', src: 'assets/market/envios.jpg', slug: 'tienda-online-cuba/productos-envio-cuba'},
    {name: 'Alimentos', alt: 'Alimentos', src: 'assets/market/alimentos.png', slug: 'tienda-online-cuba/comida'},
    {name: 'Bebidas', alt: 'Bebidas', src: 'assets/market/bebidas.png', slug: 'tienda-online-cuba/bebida'},
    {name: 'Combos', alt: 'Combos', src: 'assets/market/combos1.jpg', slug: 'tienda-online-cuba/combos'},
    {name: 'Hogar', alt: 'Hogar', src: 'assets/market/electrodomesticos.jpg', slug: 'tienda-online-cuba/electrodomesticos-hogar'},
    {name: 'Tecnología', alt: 'Tecnología', src: 'assets/market/tecnologia.png', slug: 'tienda-online-cuba/celulares-computadoras'},
    {name: 'Aseo y Belleza', alt: 'Aseo y Belleza', src: 'assets/market/aseo.png', slug: 'tienda-online-cuba/aseo'},
    {name: 'Automotriz', alt: 'Automotriz', src: 'assets/market/automotriz.png', slug: 'tienda-online-cuba/piezas-motos-carros'},
    {name: 'Farmacia y Salud', alt: 'Farmacia y Salud', src: 'assets/market/farmacia.jpg', slug: 'tienda-online-cuba/medicamentos'},
    {name: 'Ferretería', alt: 'Ferretería', src: 'assets/market/ferreteria.png', slug: 'tienda-online-cuba/ferreteria'},
    {name: 'Restaurante', alt: 'Restaurante', src: 'assets/market/restaurante.jpg', slug: 'tienda-online-cuba/comida-restaurante'}];
  constructor(@Inject(PLATFORM_ID) private platformId) { }

  ngOnInit(): void {
    let owl;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        owl = $('#category-slider').owlCarousel({
          autoplay: false,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          smartSpeed: 500,
          loop: true,
          responsiveClass: true,
          nav : true,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
          margin: 20,
          dots: true,
          responsive: {
            0: {
              items: 3,
            },
            576: {
              items: 4
            },
            768: {
              items: 4
            },
            992: {
              items: 5
            },
            1200: {
              items: 6
            },
            2560: {
              items: 6
            }
          }
        });
      }, 500);
    }
  }
}
